<template>
  <div class="row">
    <div class="col-sm-12">
      <h4>Dossier : {{dossier.title}}</h4>
      <div class="za-label">Historique
        <a class="za-label-action" v-on:click="editMode('status')"><i class="fas fa-plus fa-spacer" aria-hidden="true"></i>Ajouter</a>
      </div>

      <div class="row" style='margin-top:25px' v-show="!readmode.status">
        <div class="col-sm-5">
          <div class="form-group">
            <label class="control-label">Statut * </label>
            <select ref="status" v-model="status" class="form-control">
              <option value="" selected>Choisir</option>
              <option v-for="option in status_option" v-bind:value="option.status_id" v-bind:key="option.status_id">
                {{ option.status_name}}
              </option>
            </select>
            <label class="error" v-if="errors.status">{{ errors.status }}</label>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group">
            <label class="control-label">Date * </label>
            <datepicker :format="format" :language="fr" :value="effective_at" @input="effective_at = fixDate($event)"  input-class="form-control"></datepicker>
            <label class="error" v-if="errors.effective_at">{{ errors.effective_at }}</label>
          </div>
        </div>
        <div class="col-sm-12" style="padding-top:10px">
          <trumbowyg :config="$trumbowygConfig" class="form-control" v-model="ticket_description" placeholder="Entrer la description..."></trumbowyg>
        </div>
        <div class="col-sm-12" style="margin-top:10px">
          <button type="button" class="btn btn-primary btn-sm" v-on:click="save_ticket('designation_history')"><i class="fas fa-save" aria-hidden="true"></i> Enregistrer</button>
          <button type="button" class="btn btn-link btn-sm" v-on:click="cancelEditMode('status')">Annuler</button>
        </div>
      </div>

      <div class="row" style='margin-top:10px'>
        <div class="col-sm-12">
          <div v-for="(ticket, key) in tickets" :key="ticket.ticket_id">
            <div class="app_row" v-if="key==0" @click="$router.push({ name: 'billet', params: { ticket_id: ticket.ticket_id }})">
              {{ticket.effective_at.substring(0,10)}} {{ticket.status}}
            </div>
            <div class="app_row" v-else="" @click="$router.push({ name: 'billet', params: { ticket_id: ticket.ticket_id }})">
              <span class="text-muted">{{ticket.effective_at.substring(0,10)}} {{ticket.status}}</span>
            </div>
          </div>
        </div>
      </div>


      <div class="za-label">Service
        <a v-show="showedit" class="za-label-action" v-on:click="editMode('service')"><i   class="fas fa-plus fa-spacer" aria-hidden="true"></i>Ajouter</a>
      </div>

      <div class="row" style='margin-top:25px' v-show="!readmode.service">
        <div class="col-sm-6">
          <div class="form-group">
            <select ref="service" v-model="service_id" class="form-control">
              <option value="" selected>Choisir</option>
              <option v-for="option in services" v-bind:value="option.service_id" v-bind:key="option.service_id">
                {{ option.service_name}}
              </option>
            </select>
            <label class="error" v-if="errors.service">{{ errors.service }}</label>
          </div>
        </div>
        <div class="col-sm-12" style="margin-top:10px">
          <button type="button" class="btn btn-primary btn-sm" v-on:click="save_service"><i class="fas fa-save" aria-hidden="true"></i> Enregistrer</button>
          <button type="button" class="btn btn-link btn-sm" v-on:click="cancelEditMode('service')">Annuler</button>
        </div>
      </div>

      <div class="row" style='margin-top:10px'>
        <div class="col-sm-12">
          <div v-for="(service, key) in services_dossier" :key="service.service_id">
            <div class="app_row row">
                <div class=" col-sm-11" @click="$router.push({ name: 'service', params: { service_id: service.service_id }})">{{service.service_name}}</div>
                <div class="col-sm-1"><a  v-show="showedit" v-on:click="confirm_delete_service(service.service_id)" style="cursor:pointer"><em class="fas fa-trash-alt" aria-hidden="true"></em></a></div>
            </div>
          </div>
        </div>
      </div>





      <div class="za-label">Appréciation
        <a v-show="showedit" class="za-label-action" v-on:click="editMode('appreciation')" ><i class="fas fa-plus fa-spacer" aria-hidden="true"></i>Ajouter</a>
      </div>
      <div class="row za-add" v-show="!readmode.appreciation">
        <div class="col-sm-5">
          <div class="form-group">
            <label class="control-label">Statut * </label>
            <select v-model="appreciation" class="form-control">
              <option value="" selected>Choisir</option>
              <option v-for="option in appreciation_option" :value="option.status_id" :key="option.status_id">
                {{ option.status_name}}
              </option>
            </select>
            <label class="error" v-if="errors.appreciation">{{ errors.appreciation }}</label>
          </div>
        </div>
        <div class="col-sm-12" style="padding-top:10px">
          <trumbowyg :config="$trumbowygConfig" class="form-control" v-model="description_appreciation" placeholder="Entrer l'explication..."></trumbowyg>
          <label class="error" v-if="errors.description_appreciation">{{ errors.description_appreciation }}</label>
        </div>

        <div class="col-sm-12" style="padding-top:10px">
          <div style="margin-top:5px">
            <button type="button" class="btn btn-primary btn-sm" v-on:click="save_ticket('designation_appreciation')"><i class="fas fa-save" aria-hidden="true"></i> Enregistrer</button>
            <button type="button" class="btn btn-link btn-sm" v-on:click="cancelEditMode('appreciation')">Annuler</button>
          </div>
        </div>
      </div>
      
      <div class="row" style='margin-top:10px'>
        <div class="col-sm-12">
          <div v-for="(ticket, key) in tickets_appreciation" :key="ticket.ticket_id">
            <div class="app_row" v-if="key==0" @click="$router.push({ name: 'billet', params: { ticket_id: ticket.ticket_id }})">
              {{ticket.effective_at}} - {{ticket.created_by}} - <span class="badge" :style="firstAppreciationColor" >{{ticket.status}}</span>
            </div>
            <div class="app_row" v-else="" @click="$router.push({ name: 'billet', params: { ticket_id: ticket.ticket_id }})">
              <span class="text-muted">{{ticket.effective_at}} - {{ticket.created_by}} - {{ticket.status}}</span>
            </div>
          </div>
        </div>
      </div>

      <ListDocuments :parent-id="$route.params.designation_dossier_id" parent-type="designation_dossier" :service-provider-id="$route.params.service_provider_id"></ListDocuments>

      <div class="row" style='margin-top:10px'>
        <div class="col-sm-12">
          <div class="form-group">
            <div class="za-label">Titre</div>
            <div :class="{za_editbox: showedit}" v-if="readmode.title" v-on:click="editMode('title')">{{dossier.title}}</div>
            <span v-show="!readmode.title">
              <input ref='title' class="form-control" v-model="dossier.title" autofocus>
              <label class="error" v-if="errors.title">{{ errors.title }}</label>
              <div style="margin-top:5px">
                <button type="button" class="btn btn-primary btn-sm" v-on:click="save()"><i class="fas fa-save" aria-hidden="true"></i> Enregistrer</button>
                <button type="button" class="btn btn-link btn-sm" v-on:click="cancelEditMode('title')">Annuler</button>
              </div>
            </span>
          </div>


          <div class="form-group">
            <div class="row" style='margin-top:10px'>
              <div class="col-sm-6">
                <div class="za-label">Type de dossier</div>
                <select :disabled="!showedit" v-model="dossier.dossier_type" class="form-control" v-on:change="save">
                  <option v-for="option in dossier_types" :value="option.key"
                    :key="option.key">
                    {{ option.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="row" style='margin-top:10px'>
              <div class="col-sm-6">
                <div class="za-label">Date due anticipée * </div>
                <datepicker :disabled="!showedit" :format="format" :language="fr" :value="dueDate" @input="dueDate = $event; save();" input-class="form-control"></datepicker>
                <label class="error" v-if="errors.due_date">{{ errors.due_date }}</label>
              </div>
            </div>
          </div>


          <div class="form-group">
            <div class="za-label">Description</div>
            <div :class="{za_editbox: showedit}" v-if="readmode.description" v-on:click="editMode('description')">
                <em v-if="!dossier.description" class="text-muted">Entrer une description...</em>
                <div v-html="dossier.description"></div>
            </div>
            <span v-show="!readmode.description">
              <trumbowyg :config="config" style="height:100px" class="form-control" v-model="dossier.description"></trumbowyg>
              <label class="error" v-if="errors.description">{{ errors.description }}</label>
              <div style="margin-top:5px">
                <button type="button" class="btn btn-primary btn-sm" v-on:click="save()"><i class="fas fa-save" aria-hidden="true"></i> Enregistrer</button>
                <button type="button" class="btn btn-link btn-sm" v-on:click="cancelEditMode('description')">Annuler</button>
              </div>
            </span>
          </div>
        </div>
      </div>

      <hr style="color:#d0d0d0;width:100%;height:0;border:0.5px solid">
      <ListComment :parent_id="$route.params.designation_dossier_id" parent_class="designation_dossier" :readonly="!showedit"></ListComment>
      <div class="row" style='margin-top:25px'>
        <div class="col-sm-12">
          <button class="btn btn-default" v-on:click="back">Retour</button>
        </div>
      </div>

      <transition name="modal" >
        <div class="modal-mask" v-show="show_confirm_service">
            <div class="modal-block modal-block">
              <section class="panel">
                <header class="panel-heading">
                    <strong>Êtes-vous certain?</strong>
                </header>
                <div class="panel-body">
                  <div class="modal-wrapper">
                    <div class="modal-text">
                      <p>Êtes-vous certain de vouloir supprimer ce service?</p>
                    </div>
                  </div>
                </div>
                <footer class="panel-footer">
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <a class="btn btn-default" v-on:click="cancel_delete_service">Non</a>&nbsp;&nbsp;<a class="btn btn-default" v-on:click="delete_service">Oui</a>
                    </div>
                  </div>
                </footer>
              </section>
            </div>
        </div>
      </transition>

    </div>
  </div>
</template>
<style>
.app_row:hover {
  background-color: #e0e0e0;
  cursor: pointer;
}
</style>

<script>
import ListComment from '@/components/ListComment.vue'
import ListDocuments from '@/components/ListDocuments.vue'

import axios from 'axios';
import Datepicker from 'vuejs-datepicker'
import $ from 'jquery'

import {en, fr} from 'vuejs-datepicker/dist/locale'


export default {
  data: function() {return {
    designation_dossier_id:'',
    serviceprovider:{},
    dossier:{},
    tickets:{},
    tickets_appreciation:{},
    services:{},
    service_id:'',
    services_dossier:{},
    status:'',
    appreciation:'',
    effective_at:'',
    status_option: {},
    appreciation_option: {},
    ticket_title:'',
    ticket_description:'',
    responsable:'',
    title:'',
    dossier_types:{},
    description:'',
    description_appreciation:'',
    errors:{
      status:'',appreciation:'',description_appreciation:'',effective_at:'',title:'',description:'',due_date:'',service:''
    },
    show_confirm_service:false,
    showedit:false,
    readmode: {
      status: true,
      title: true,
      description: true,
      appreciation:true,
      service:true
    },
    field_backup: null,
    config: this.$trumbowygConfig,
    format:'yyyy-MM-dd',
    en: en,
    fr: fr,

  }},
  name: 'ServiceProviderDossierDetail',
  components: {
    Datepicker,
    ListComment,
    ListDocuments
  },
  computed: {
    
    firstAppreciationColor() {
      switch(this.tickets_appreciation[0].ticket_status_key) {
        case 'da_conforme': return "background-color: #18B358;";
        case 'da_non_conforme': return "background-color: #F99A91;";
        case 'da_non_evalue': return "background-color: #AB4FD2;";
        case 'da_revue_preliminaire': return "background-color: #399ADB;";
        default: return "";
      }
    },
    dueDate: {
      get() {
        if (!this.dossier || !this.dossier.due_date) { return }
        return this.parseDate(this.dossier.due_date)
      },
      set(newVal) {
        this.dossier.due_date = this.fixDate(newVal)
      }
    }
  },
  methods: {

    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/service_provider_dossier.php',
          { params: {dossier_id:this.$route.params.designation_dossier_id,service_provider_id: this.$route.params.service_provider_id}})
        .then(response => (
          this.$checkApiErrors(response.data),
          this.serviceprovider = response.data.serviceprovider,
          this.dossier = response.data.dossier,
          this.dossier_types = response.data.dossier_types,
          this.showedit=this.dossier.showedit,
          this.status_option = response.data.ticket_status,
          this.appreciation_option = response.data.ticket_appreciation_status,
          this.ticket_title = this.dossier.title,
          this.tickets = response.data.tickets,
          this.tickets_appreciation = response.data.tickets_appreciation,
          this.services_dossier = response.data.dossier.service_id_list,
          this.services = response.data.services
          ))
    },
    back: function()
    {
      this.$router.go(-1);
    },

    save: function()
    {
      var empty_field = false;

      if(this.dossier.title == '')
      {
        this.errors.title = this.$messages.required;
        empty_field = true;
      }
      else
        this.errors.title = '';

      if(!empty_field)
      {
        var data = {
          dossier_id:this.$route.params.designation_dossier_id,
          name:this.dossier.title,
          dossier_type:this.dossier.dossier_type,
          description:this.dossier.description,
          due_date:this.dossier.due_date,
          service_provider_id:this.$route.params.service_provider_id
        }
        axios
          .post(this.$root.$data.server_base + '/api/designation_dossier_save.php',
            data,
            {headers:{
                'Content-Type': 'application/json',
          }})
          .then(response => {
            this.$checkApiErrors(response.data);
            this.readmode.title=true,
            this.readmode.description=true
          })
      }
    },

    save_service: function()
    {
      var empty_field = false;

      if(this.service_id == '')
      {
        this.errors.service = this.$messages.required;
        empty_field = true;
      }
      else
        this.errors.service = '';

      if(!empty_field)
      {
        var data = {
          dossier_id:this.$route.params.designation_dossier_id,
          service_provider_id:this.$route.params.service_provider_id,
          service_id:this.service_id
        }
        axios
          .post(this.$root.$data.server_base + '/api/service_dossier_save.php',
            data,
            {headers:{
                'Content-Type': 'application/json',
          }})
          .then(response => {
            this.readmode.service=true;
            this.service_id='';
            this.refresh();
          })
      }
    },

    confirm_delete_service: function(service_id)
    {
        this.show_confirm_service=true;
        this.service_id=service_id;
    },

    cancel_delete_service: function()
    {
      this.show_confirm_service=false;
      this.service_id='';
    },
    
    delete_service: function()
    {
      var data = {
        dossier_id:this.$route.params.designation_dossier_id,
        service_id:this.service_id
      }
      
      axios
          .post(this.$root.$data.server_base + '/api/delete_service_dossier.php',
            data,
            {headers:{
                'Content-Type': 'application/json',
          }})
          .then(response => {
            this.show_confirm_service=false;
            this.service_id='';
            this.refresh();
          })
    },

    save_ticket: function(ticket_type_key)
    {
      var empty_field = false;

      if(ticket_type_key=='designation_history')
      {
        if(this.status == '')
        {
          this.errors.status = this.$messages.required;
          empty_field = true;
        }
        else
          this.errors.status = '';

        if(this.effective_at == '')
        {
          this.errors.effective_at = this.$messages.required;
          empty_field = true;
        }
        else
          this.errors.effective_at = '';


      }
      else
      {
        if(this.appreciation == '')
        {
          this.errors.appreciation = this.$messages.required;
          empty_field = true;
        }
        else
          this.errors.appreciation = '';

        if(this.description_appreciation == '')
        {
          this.errors.description_appreciation = this.$messages.required;
          empty_field = true;
        }
        else
          this.errors.description_appreciation = '';
      }


      if(!empty_field)
      {
        let data;

        if(ticket_type_key=='designation_history')
        {
          data = {
            designation_dossier_id:this.$route.params.designation_dossier_id,
            ticket_type_key: ticket_type_key,
            ticket_status:this.status,
            responsable:this.responsable,
            service_provider_id:this.$route.params.service_provider_id,
            title:this.ticket_title,
            description:this.ticket_description,
            effective_at:this.effective_at
          }


        }
        else
        {
          data = {
            ticket_type_key: ticket_type_key,
            ticket_status:this.appreciation,
            title:"Appréciation d'un dossier "+this.dossier.title,
            service_provider_id:this.$route.params.service_provider_id,
            designation_dossier_id:this.$route.params.designation_dossier_id,
            description: this.description_appreciation
          }
        }
        
        axios
          .post(this.$root.$data.server_base + '/api/ticket_save.php',
            data,
            {headers:{
                'Content-Type': 'application/json',
          }})
          .then(() => {
            if(ticket_type_key=='designation_history')
            {
              this.readmode.status=true;
              this.status='';
              this.effective_at='';
              this.ticket_description='';
              this.refresh();
            }
            else
            {
              this.readmode.appreciation=true;
              this.appreciation='';
              this.description_appreciation='';
              this.refresh();
            }
            
          })
      }
    },
    fixDate(event) {
      if (event === null) { return null }
      return this.moment(event).format('YYYY-MM-DD');
    },
    parseDate(dateStr) {
      const [year, month, date] = dateStr.substring(0, 10).split('-')
      if (year === undefined || month === undefined || date === undefined ) { return null }
      if (Number(year) === 0 || Number(month) === 0 || Number(date) === 0 ) { return null }
      return new Date(year, month - 1, date)
    },

    editMode: function(field)
    {
      if(field!='status')
      {
        if(!this.showedit) return;
      }
      

      for (let [key, value] of Object.entries(this.readmode)) {
        if(key != field && value==false) {
          // Warn only if value changed
          if(this.dossier[key]!=this.field_backup) {
            this.errors[key]="Sauvegardez ou annulez les changements avant de passer à un autre champ";
            return;
          }
          else {
            this.cancelEditMode(key);
          }
        }
      }
      this.readmode[field] = false;
      this.field_backup = this.dossier[field];
      this.$nextTick(() => {if(this.$refs[field]) this.$refs[field].focus();})
    },

    cancelEditMode: function(field)
    {
      this.readmode[field] = true;
      this.dossier[field] = this.field_backup;
      this.errors[field] = "";
      if(field=="status") {
        this.status='';
        this.effective_at='';
      }
      if(field=="appreciation") {
        this.appreciation='';
        this.description_appreciation='';
      }
      if(field=="service") {
        this.service='';
      }
    },

  },
  mounted () {
    this.refresh();

  }
}
</script>
